//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/index'
import BuildingService from '@/service/building'

import BuildingViewImg from '@/components/business/building_view_img'
import TopRightShare from '@/components/views/top_right_share'
import detailSubPage from '@/common/mixins/detailSubPage'
import Consultants from '@/components/business/_excellent_consultants'
import CommonFooter from '../_components/_common_footer'

import { handleViewCount, getTags } from '@/common/utils/map_view_data'

import { getInfoItems } from '../utils'

const handleIntro = (intros) => {
    return intros.reduce((prev, intro) => {
        const enterFlag = '<br/>'
        const splited_contents = intro.replace(/(\r\n|\n)/g, enterFlag).split(enterFlag)
        return prev.concat(splited_contents)
    }, [])
}

export default {
    mixins: [
        detailSubPage
    ],
    name: 'HOUSE_INFO',
    data () {
        return {
            img_url: '',
            view_count: 0,
            building_id: '',
            name: '',
            address_str: '',
            tags: [],
            detail: {
                base_info: [],
                other_info: [],
                intro: []
            },
            excellent_consultants: []
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            const { house_id, building_id, type } = this.$route.query
            this.building_id = building_id
            this.$wx.showLoading()
            Service.getBuilding(building_id, house_id).then(data => {
                const { photos_urls } = data
                this.name = data.name
                this.address_str = [data.zone, data.zone_section].filter(val => val).join('-')
                this.tags = getTags(data)
                this.view_count = handleViewCount(data.view_count)
                this.img_url = photos_urls && photos_urls.length ? photos_urls[0] : ''
                this.address = `${data.zone ? `${data.zone}-` : ''}${data.address || ''}`
                const { details } = data
                const baseItems = getInfoItems(type, data.usage)
                const otherInfo = details['周边设施'] || {}
                const OTHER_ITEMS = Object.keys(otherInfo)
                const handleItems = (obj) => {
                    return (items, item) => {
                        if (obj[item]) {
                            items.push({
                                name: `${item}:`,
                                value: obj[item]
                            })
                        }
                        return items
                    }
                }
                this.detail = {
                    base_info: baseItems.reduce(handleItems(details), []),
                    other_info: OTHER_ITEMS.reduce(handleItems(otherInfo), []),
                    intro: handleIntro(details['项目简介'])
                }
                this.getConsultants(building_id)
                this.$wx.hideLoading()
            })
        },
        getConsultants (id) {
            BuildingService.excellentConsultants(id).then((data) => {
                this.excellent_consultants = data.slice(0, 3)
            })
        }
    },
    components: {
        BuildingViewImg,
        TopRightShare,
        Consultants,
        CommonFooter,

    }
}
